// 🔧 promotion_page_header.js
// ✅ Purpose: Reusable page header for the LGV Promotion Engine
// ✅ Features:
// - Provides consistent Promotion Engine page titles
// - Supports subtitle/help text
// - Supports optional right-side action buttons
// - Keeps Promotion Engine admin pages visually uniform
// - Fully block-commented for clarity and future devs

import React from "react";

/**
 * PromotionPageHeader
 *
 * Reusable header component for Promotion Engine admin pages.
 *
 * This keeps future pages consistent:
 * - Dashboard
 * - Idea Bank
 * - Queue
 * - Scheduler
 * - Follow Targets
 * - Settings
 *
 * @param {string} title - Main page title.
 * @param {string} subtitle - Optional supporting description.
 * @param {React.ReactNode} actions - Optional right-side action buttons.
 */
const PromotionPageHeader = ({
  title = "Promotion Engine",
  subtitle = "",
  actions = null,
}) => {
  return (
    <div className="card shadow-sm border-0 mb-4">
      <div className="card-body">
        <div className="row align-items-center g-3">
          <div className="col-12 col-md">
            <p className="text-uppercase text-muted small fw-bold mb-1">
              LGV Admin Platform
            </p>

            <h1 className="h3 fw-bold mb-2">
              {title}
            </h1>

            {subtitle && (
              <p className="text-muted mb-0">
                {subtitle}
              </p>
            )}
          </div>

          {actions && (
            <div className="col-12 col-md-auto">
              <div className="d-flex flex-wrap gap-2 justify-content-md-end">
                {actions}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PromotionPageHeader;